import { Component, OnInit } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ObserverService } from '../../services//observer.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.page.html',
    styleUrls: ['./logout.page.scss'],
})

export class LogoutPage implements OnInit {
    spinner = null;

    constructor(
        private loadingController: LoadingController,
        private router: Router,
        private authService: AuthService,
        private observerService: ObserverService
    ) { }

    ngOnInit() { }

    ionViewDidEnter() {
        this.authService.isLoggedIn().then(() => {
            this.presentSpinner('Logging out').then(() => {
                this.observerService.publish('logged_out', {});
                this.authService.revokeAccessToken().then(() => {
                    this.spinner.dismiss();
                    this.authService.clearSession();
                    this.router.navigate(['start'], { replaceUrl: true });
                })
                .catch(() => {
                    this.spinner.dismiss();
                    this.authService.clearSession();
                    this.router.navigate(['start'], { replaceUrl: true });
                });
            });
        }).catch(() => {
            this.authService.clearSession();
            this.router.navigate(['start'], { replaceUrl: true });
        });
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
        });
        await this.spinner.present();
    }

}
